import React from "react";
import "./style/FAQSection.css";
import Accordion from "react-bootstrap/Accordion";
import 'bootstrap/dist/css/bootstrap.min.css';

const faqs = [
  {
    question: "What services does Shalisha Enterprise provide?",
    answer:
      "Shalisha Enterprise specializes in three core areas: Mosquito Protection (nets and screens), Interior Design (residential and commercial spaces), and Pest Control Services (eco-friendly and effective solutions).",
  },
  {
    question: "How effective are your mosquito protection solutions?",
    answer:
      "Our mosquito nets and barrier-free screen systems are designed using high-quality materials that ensure long-lasting protection and maximum ventilation, offering a safe and mosquito-free environment.",
  },
  {
    question: "Do you offer customized interior design services?",
    answer:
      "Yes, we provide fully customized interior design services based on your preferences, space functionality, and budget. From concept to completion, we take care of everything.",
  },
  {
    question: "What types of pests do you control in your pest control services?",
    answer:
      "Our pest control services cover a wide range of common pests, including mosquitoes, cockroaches, termites, ants, rodents, and bed bugs—using child- and pet-safe methods.",
  },
  {
    question: "Are your products and treatments safe for children and pets?",
    answer:
      "Absolutely. All our mosquito nets and pest control treatments are eco-friendly and non-toxic, ensuring the safety of your loved ones.",
  },
  {
    question: "How can I book a consultation with Shalisha Enterprise?",
    answer:
      "Booking is easy! You can fill out the enquiry form on our website, call our customer care number, or send us a message on WhatsApp to schedule a free consultation.",
  },
];

const FAQSection = () => {
  return (
    <section className="faq-section bg-dark text-white py-5">
      <div className="container">
        <div className="row align-items-center gx-5">
          {/* Left Image */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <img
              src="/assets/faq-girl.webp"
              alt="FAQ illustration"
              className="img-fluid rounded faq-image"
            />
          </div>

          {/* Right FAQ */}
          <div className="col-lg-6">
            <p className="faq-tag mb-2">QUESTIONS</p>
            <h2 className="faq-title mb-4">Frequently asked questions</h2>
            <Accordion defaultActiveKey="0" flush className="custom-accordion">
              {faqs.map((faq, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={index}
                  data-aos="fade-up" // Adding fade-up animation
                >
                  <Accordion.Header>{faq.question}</Accordion.Header>
                  <Accordion.Body>{faq.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
